import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_PAYLOAD_KEY;

/**
 * Encrypts a plain JavaScript object or string into AES-256 encrypted payload object.
 * Format: { payload: "encrypted_base64_string..." }
 */
export const encryptPayload = (data) => {
  if (data === undefined || data === null) return data;
  // If data is already an encrypted payload object, return as is
  if (
    typeof data === "object" &&
    data.payload &&
    typeof data.payload === "string"
  ) {
    return data;
  }
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    return data;
  }
  try {
    const jsonStr = typeof data === "string" ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonStr, SECRET_KEY).toString();
    return { payload: encrypted };
  } catch (err) {
    console.error("Payload encryption failed:", err);
    return data;
  }
};

/**
 * Decrypts an encrypted payload object { payload: "..." } back into a plain JavaScript object.
 */
export const decryptPayload = (encryptedObj) => {
  if (
    !encryptedObj ||
    typeof encryptedObj !== "object" ||
    !encryptedObj.payload
  ) {
    return encryptedObj;
  }
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedObj.payload, SECRET_KEY);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedStr) return encryptedObj;
    return JSON.parse(decryptedStr);
  } catch (err) {
    console.error("Payload decryption failed:", err);
    return encryptedObj;
  }
};
